import React from 'react';
import ReactDOM from 'react-dom';
import './assets/Styles/bootstrap.min.css';
import 'react-notifications-component/dist/theme.css';
import 'react-responsive-modal/styles.css';
import './assets/Styles/search-select.css'
import './assets/Styles/font.css';
import './assets/Styles/custom-font-icon.css';
import './assets/Styles/styles.css';
import {BrowserRouter} from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Header} from "./components";
import {ReactNotifications} from "react-notifications-component";
import {Provider} from "react-redux";
import store from "./redux/store";

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <ReactNotifications />
            <Header />
            <App/>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
